import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import Indicator from "./Indicator"
import PlaceholderWidget from "../../common/grid/widgets/PlaceholderWidget"
import { Labels } from "../../../util/Translations"
import { IIndicators } from "../index"

type StateProps = IIndicators

type Props = StateProps

const { NoIndicatorsToShow } = Labels
export const Indicators = ({ isLoading, indicators }: Props): JSX.Element => (
    <>
        {!isLoading && indicators.length > 0 && (
            <div
                className="tw-flex tw-items-start tw-flex-wrap tw-px-2"
                data-ft-component="indicatorsList"
            >
                {indicators.map((indicator) => (
                    <Indicator key={indicator.id} {...indicator} />
                ))}
            </div>
        )}

        {!isLoading && indicators.length === 0 && (
            <div
                className="tw-px-5 label is-dimmed"
                data-ft-component="indicatorsNothingFound"
            >
                <p>{NoIndicatorsToShow}</p>
            </div>
        )}

        {isLoading && (
            <div className="tw-flex tw-items-start tw-flex-wrap tw-px-2 is-placeholder is-loading">
                <PlaceholderWidget />
                <PlaceholderWidget />
                <PlaceholderWidget />
            </div>
        )}
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => state.indicators

export default connect(mapStateToProps, {})(Indicators)
